import React, { useContext, useEffect, useState } from 'react';

import apiMethods from '../../../../apis';
import useGet from '../../../../services/hooks/http/useGet';
import utils from '../../../../services/utils';
import Context from '../../../../store/context';
import BackButton from '../../../Buttons/BackButton/BackButton';
import FieldBold from '../../../Fields/FieldBold/FieldBold';
import InvoiceDetail from '../../../Details/InvoiceDetail/InvoiceDetail';
import Tags from '../../../Tags/Tags';
import Tooltip from '../../../Tooltip/Tooltip';
import InvoiceCard from './InvoiceCard/InvoiceCard';

import classes from './ListInvoices.module.scss';
import { statusAccountTransaction } from '../../../../store/constants/statusDruoAccounts';

const ListInvoices = ({ supplierName, purchasesItems, totalValue, backButton, meloStatus }) => {
  const [purchaseState, setPurchaseState] = useState(null);
  const [fetchGet, setFetchGet] = useState({ purchaseId: null, fetch: false });

  const {
    modal: { showError }
  } = useContext(Context);

  const {
    isError: getError,
    isSuccess: getSuccess,
    data,
    errorMessage
  } = useGet(apiMethods.getPurchase, [fetchGet.purchaseId], fetchGet.fetch);

  useEffect(() => {
    if (getSuccess) {
      const payedValue = data.payments.reduce((prev, payment) => prev + payment.value, 0);
      //setPurchaseState({ ...purchaseItem, payedValue, pendingValue: purchaseItem.totalValue - payedValue });
      setPurchaseState({
        ...data,
        totalValue: data.payableAmountAfterRetentions,
        payedValue,
        totalValueWasPayed: data.currentPayment?.totalValueWasPayed,
        dateCurrentPay: data.currentPayment?.date,
        meloStatus: data.currentPayment?.meloStatus,
        pendingValue: data.payableAmountAfterRetentions - payedValue
      });
      setFetchGet({ purchaseId: null, fetch: false });
    } else if (getError) {
      showError({ title: 'Traer cuenta de cobro', description: errorMessage });
    }
  }, [data, errorMessage, getError, getSuccess, showError]);

  const viewSpecificInvoice = ({ purchaseId }) => {
    setFetchGet({ purchaseId: purchaseId, fetch: true });
  };

  const cleanState = () => {
    setPurchaseState(null);
  };
  return (
    <>
      {!purchaseState ? (
        <div className={classes.content}>
          {backButton && backButton}
          <span className='bold-20'>Detalles</span>
          <FieldBold title='PROVEEDOR' value={supplierName} />
          <FieldBold title='ESTADO DE PAGO'>
            <Tooltip content={statusAccountTransaction[meloStatus].tooltip}>
              <Tags text={statusAccountTransaction[meloStatus].label} type={statusAccountTransaction[meloStatus].color} />
            </Tooltip>
          </FieldBold>
          {purchasesItems.map((purchases, idx) => (
            <InvoiceCard key={idx} purchases={purchases} onClick={viewSpecificInvoice} />
          ))}
          <FieldBold title='TOTAL POR PROVEEDOR' value={utils.moneyFormat(totalValue)} />
        </div>
      ) : (
        <div>
          <BackButton className={classes.detail} onClick={cleanState} />
          <InvoiceDetail isHistoryPayment={true} supplier={supplierName} invoice={purchaseState} />
        </div>
      )}
    </>
  );
};

export default ListInvoices;
